<div class="nt-container">
  <app-title-container backPath="/treaty-assessments">
    <h1>New Bordereau Assessment</h1>
  </app-title-container>
  <app-divider height="2px"></app-divider>

  <div class="nt-content-container">
    @if (secondStep() === 'none') {
      <div class="treaty-card-container">
        <!-- Casualty card -->
        @let casualty = treatyTexts.casualty;
        <div class="treaty-card">
          <h2>{{ casualty.title }}</h2>

          <div class="treaty-card-info">
            <em class="material-symbols-outlined">info</em>
            <div class="treaty-card-info-text">{{ casualty.info }}</div>
          </div>

          <div class="treaty-card-text">{{ casualty.description }}</div>
          <button class="treaty-card-button" mat-flat-button (click)="goToNextStep(casualty.id)">{{ casualty.buttonText }}</button>
        </div>

        <!-- Property card -->
        @let property = treatyTexts.property;
        <div class="treaty-card">
          <h2>{{ property.title }}</h2>
          <div class="treaty-card-info">
            <em class="material-symbols-outlined">info</em>
            <div class="treaty-card-info-text">{{ property.info }}</div>
          </div>
          <div class="treaty-card-text">{{ property.description }}</div>
          <button class="treaty-card-button" mat-flat-button (click)="goToNextStep(property.id)">{{ property.buttonText }}</button>
        </div>
      </div>
    } @else {
      @let current = secondStep();
      @let treatyType = current !== 'none' ? treatyTexts[current] : undefined;

      <div class="treaty-card" style="width: 700px">
        <div class="next-step-title-container">
          <button class="cancel-button" mat-icon-button type="button" (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <h2>{{ treatyType?.actionTitle }}</h2>
        </div>

        <div class="treaty-card-text">{{ treatyType?.description }}</div>
        <div class="treaty-input on-background2">
          <mat-form-field>
            <mat-label>Portfolio name (optional)</mat-label>
            <input matInput [formControl]="portfolioControl" />
          </mat-form-field>
        </div>
        <div>
          <button class="treaty-card-button" mat-button (click)="dowloadTemplate(treatyType!.id)">Download Template</button>
          <br />
          <input hidden type="file" #fileInputUpload accept=".xls,.xlsx" (change)="uploadExcel($event, fileInputUpload, treatyType!.id)" />
          <button mat-flat-button class="treaty-card-button-mt" [disabled]="isLoadingSubmit()" (click)="fileInputUpload.click()">
            @if (isLoadingSubmit()) {
              <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
            }
            Upload Completed Template
          </button>
        </div>
      </div>
    }
  </div>
</div>
